import { render } from "./X9.vue?vue&type=template&id=47bd4caa"
import script from "./X9.vue?vue&type=script&lang=js"
export * from "./X9.vue?vue&type=script&lang=js"

import "./X9.vue?vue&type=style&index=0&id=47bd4caa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__